import { Store } from '@ngxs/store';
import { buildUrl } from '@trimble-gcs/common';
import { AppState } from '../app-state/app.state';

export function openInNumark(store: Store, scandataIds: string[]) {
  const baseUrl = store.selectSnapshot(AppState.settings).numarkUrl;
  const project = store.selectSnapshot(AppState.project);
  const region = store.selectSnapshot(AppState.connectRegion);

  const query = `?tenantTrn=trn:connect:projects:${region?.location}:${project?.id}&pointCloudIds=${scandataIds.join(',')}`;
  const url = buildUrl(baseUrl, query);

  window.open(url, 'viewInNumark');
}
